var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-400 rounded-full w-8 h-8 flex items-center justify-center cursor-pointer"},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }